import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthDialog({ open, onOpenChange }) {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, signup } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === "login") {
        await login(email, password);
        toast.success("Welcome back!");
      } else {
        await signup(email, password, name);
        toast.success("Account created — Let's go!");
      }
      onOpenChange(false);
      setEmail(""); setPassword(""); setName("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="auth-dialog" className="rounded-none border-2 border-halo-navy max-w-md">
        <DialogHeader>
          <DialogTitle className="font-sports uppercase tracking-tight text-3xl">
            {mode === "login" ? "Sign In" : "Join the Section"}
          </DialogTitle>
          <DialogDescription className="font-body text-sm text-halo-navy/60">
            {mode === "login" ? "Welcome back to the section." : "Create an account to comment and rep the section."}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 pt-2">
          {mode === "signup" && (
            <div>
              <Label className="font-sports uppercase tracking-widest text-xs">Name</Label>
              <Input
                data-testid="auth-name-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className="rounded-none border-2 mt-1 focus-visible:ring-halo-red focus-visible:border-halo-red"
              />
            </div>
          )}
          <div>
            <Label className="font-sports uppercase tracking-widest text-xs">Email</Label>
            <Input
              data-testid="auth-email-input"
              type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="rounded-none border-2 mt-1 focus-visible:ring-halo-red focus-visible:border-halo-red"
            />
          </div>
          <div>
            <Label className="font-sports uppercase tracking-widest text-xs">Password</Label>
            <Input
              data-testid="auth-password-input"
              type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6}
              className="rounded-none border-2 mt-1 focus-visible:ring-halo-red focus-visible:border-halo-red"
            />
          </div>
          <button
            type="submit" disabled={loading}
            data-testid="auth-submit-btn"
            className="w-full bg-halo-red hover:bg-halo-redHover text-white font-sports uppercase tracking-wider py-3 disabled:opacity-50"
          >
            {loading ? "..." : mode === "login" ? "Sign In" : "Create Account"}
          </button>
          <button
            type="button"
            data-testid="auth-toggle-btn"
            onClick={() => setMode(mode === "login" ? "signup" : "login")}
            className="w-full text-center text-xs font-sports uppercase tracking-widest text-halo-navy hover:text-halo-red"
          >
            {mode === "login" ? "New here? Create account" : "Have an account? Sign in"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
